<template>
  <v-container>
    <v-row class="text-center">
      <v-col cols="12" class="d-flex justify-center align-center"> </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="d-flex justify-center align-center">
        <v-img max-width="300" src="../assets/asclogo.png"></v-img>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="d-flex justify-center align-center">
        <h2>ระบบฐานข้อมูลบุคลากรด้านการบริการทางวิชาการ</h2>
      </v-col>
      <v-col cols="12" class="d-flex justify-center align-center">
        <h3>กรุณากรอกข้อมูลเพื่อเข้าสู่ระบบ</h3>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" class="d-flex justify-center align-center">
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-text-field
            class="centered-input"
            label="รหัสบุคลากร"
            placeholder="ระบุเป็นตัวเลขติดกัน"
            outlined
            v-model="user.username"
            :rules="idRule"
            type="number"
          ></v-text-field>
          <v-text-field
            class="centered-input input-group--focused"
            :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
            :type="show ? 'text' : 'password'"
            name="input-10-2"
            outlined
            v-model="user.password"
            label="รหัสผ่าน"
            placeholder="เหมือนระบบอินทราเน็ต"
            @click:append="show = !show"
          ></v-text-field>
          <div class="d-flex justify-center align-center">
            <v-btn
              :disabled="!valid"
              :loading="signinButtonLoading"
              color="primary"
              @click="signIn"
            >
              เข้าสู่ระบบ
            </v-btn>
          </div>
        </v-form>
      </v-col>
    </v-row>

    <v-snackbar v-model="snackbar">
      ท่านไม่มีสิทธิ์ในการเข้าใช้งาน
      <template v-slot:action="{ attrs }">
        <v-btn color="pink" v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import { GlobalFunction } from "./functions";

export default {
  mixins: [GlobalFunction],
  data: () => ({
    user: {},
    snackbar: false,
    valid: true,
    show: false,
    userData: {},
    signinButtonLoading: false,

    idRule: [
      (v) => !!v || "กรุณาระบุรหัสบุคลากร",
      (v) => (v && v.length == 7) || "รหัสบุคลากรมี 7 ตำแหน่ง",
    ],
    passRule: [(v) => !!v || "กรุณาระบุรหัสผ่าน"],
  }),

  methods: {},
  watch: {},
  computed: {},
  mounted() {},
};
</script>

<style>
.pointer {
  cursor: pointer;
}
.centered-input.v-text-field .v-label {
  left: 50% !important;
  transform: translateX(-50%);
  transform-origin: top 50%;
}
.centered-input.v-text-field .v-label--active {
  left: 0% !important;
  transform: translateY(-25px) scale(0.75) translateX(0px);
}
/* @import "https://cdnjs.cloudflare.com/ajax/libs/materialize/1.0.0-beta/css/materialize.min.css"; */
</style>
